const MEDIA_BASE_URL =
  process.env.NODE_ENV === 'development'
    ? (process.env.REACT_APP_MEDIA_URL || 'http://localhost:5001')
    : '';

const isUploadPath = (url) =>
  url.startsWith('/uploads/') || url.startsWith('/api/uploads/');

export const resolveMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return url;

  const trimmed = url.trim();
  if (!trimmed) return trimmed;

  if (/^https?:\/\//.test(trimmed) || trimmed.startsWith('data:')) {
    return trimmed;
  }

  // Property media uploaded via the API lives on the backend server
  if (isUploadPath(trimmed)) {
    const path = trimmed.startsWith('/uploads/')
      ? trimmed.replace('/uploads/', '/api/uploads/')
      : trimmed;
    return `${MEDIA_BASE_URL}${path}`;
  }

  // Static assets (agent photos, legacy JPGs) are served from the frontend public folder
  return trimmed;
};
